










































import { defineComponent, ref, useFetch } from '@nuxtjs/composition-api'
import { useConfig } from '~/composables';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import { CATEGORIES_TO_REDIRECT, PRODOTTI } from '~/utils/constants/solepro/categories';
import { highlightCardCategoryTrack } from '~/helpers/trackings/24orepro/home'; 


export default defineComponent({
  setup() {
    const categories = useCategoryStore();
    const highlightSections = ref([]);
    const { config } = useConfig();
    const SIZE = 8;
    useFetch(async () => {
      await categories.load()
      try {
        const highlights = categories.rawCategories?.items[0].children.find(el => el.name.toLowerCase() == PRODOTTI).children
        highlightSections.value = Array.from(Array(Math.ceil(highlights.length / SIZE)).keys()).map((el, index) => highlights.slice(SIZE * index, (SIZE * index) + SIZE));
      } catch (e) { }
    });
    return {
      highlightSections,
      storeCode: config.value.store_code,
      size: SIZE,
      categoriesToRedirect: CATEGORIES_TO_REDIRECT
    }
  },
  methods: { 
      trackCategoryCard(val, callback) { 
        highlightCardCategoryTrack(val, callback); 
      },
      async goToLink(url, target) {
      if(target=='_blank'){
        window.open(url, target).focus()
      }else{
        this.$router.push(url);

      }
    },
    } 
})
